
import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { RackTrayRefDto, CabinetShelfRefDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-rackettrayref-container',
  templateUrl: './rackettrayref-container.component.html',
  styleUrls: ['./rackettrayref-container.component.scss']
})
export class RackettrayrefContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  cabinetshelfrefs$: Observable<CabinetShelfRefDto[]>;
  racktrayrefs$: Observable<RackTrayRefDto[]>;
  loading: boolean;
  isCompanyLoading$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.racktrayrefs$ = this.gatwayFacade.loadGateway("RackTrayRef");
    this.cabinetshelfrefs$ = this.gatwayFacade.loadGateway("CabinetShelfRef");

    this.isLoading$ = this.gatwayFacade.isLoadingGateway("RackTrayRef");

  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRackTrayRef(deletedValue: any) {
    this.gatwayFacade.remove("RackTrayRef", deletedValue);
    // this.store.dispatch(RackTrayRefStoreActions.removeRackTrayRef({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }

// this method control both the create and update
  onSubmitRackTrayRef(formValue: any) {
    console.log("form value: ", formValue);
    formValue.RackTrayRefs = formValue.RackTrayRefs.reverse();
    const pullData = formValue.RackTrayRefs;
    //const newPullData = formValue.RackTrayRefes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllRackTrayRef = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllRackTrayRef.push(pullData[i]);
    }
  }

// check if the addAllRackTrayRef array is not empty, then dispatch the data to the store
   if(addAllRackTrayRef.length !== 0) {
    this.gatwayFacade.add('RackTrayRef', addAllRackTrayRef);
    // this.store.dispatch(RackTrayRefStoreActions.addRackTrayRef({newRackTrayRef: addAllRackTrayRef}));
   }

// dispatch update data to the store
    this.gatwayFacade.update('RackTrayRef', allUpdates, ['id']);
    // this.store.dispatch(RackTrayRefStoreActions.updateRackTrayRef({updateRackTrayRef: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }

}

